import { Flex, Text, Tooltip } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { _localization } from "../../../../../../config/location";
import {
  tblPromotion,
  tblPromotionItemGiftCommand,
} from "../../../../../../model/TblPromotion";
import "./table.css";

const TableItemGiftPromotion = ({
  form,
}: {
  form: UseFormReturnType<tblPromotion, (values: tblPromotion) => tblPromotion>;
}) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });
  const [keySearch, setKeySearch] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [data, setData] = useState<tblPromotionItemGiftCommand[]>([]);
  const [dataTemp, setDataTemp] = useState<tblPromotionItemGiftCommand[]>([]);

  const entity: tblPromotionItemGiftCommand = {
    id: 0,
    promoteId: null,
    promoteDetailId: null,
    idItemPrimary: null,
    idItemGift: null,
    quantityApply: null,
    quantityMin: null,
    quantityMax: null,
    discountPercent: null,
    discountAmount: null,
    price: null,
    priceMin: null,
    priceMax: null,
    // attribute1: null,
    // attribute2: null,
    // attribute3: null,
    // attribute4: null,
    // attribute5: null,
    // attribute6: null,
    // attribute7: null,
    // attribute8: null,
    // attribute9: null,
    // attribute10: null,
    // attribute11: null,
    // attribute12: null,
    // attribute13: null,
    // attribute14: null,
    // attribute15: null,
    itemGiftCode: null,
    itemGiftName: null,
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      //   {
      //     accessorKey: "apply",
      //     header: "Áp dụng cho",
      //     size: 20,
      //   },
      {
        accessorKey: "itemGiftCode",
        header: "Mã hàng",
        size: 80,
      },
      {
        accessorKey: "itemGiftName",
        header: "Tên hàng",
        Cell: ({ renderedCellValue, cell }) => (
          <Tooltip label={renderedCellValue as string}>
            <Text truncate="end" w={500}>
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
      },
      //   {
      //     accessorKey: "startingPrice",
      //     header: "Giá bán từ",
      //   },
      //   {
      //     accessorKey: "finalPrice",
      //     header: "Đến",
      //   },
      //   {
      //     accessorKey: "pointAccumulationRate",
      //     header: "Tỷ lệ tích điểm thưởng",
      //   },
      //   {
      //     accessorKey: "bonusPoints",
      //     header: "Số điểm thưởng",
      //   },
      {
        accessorKey: "quantityApply",
        header: "SL cho phép",
        enableGlobalFilter: false,
        size: 80,
      },
      // {
      //   accessorKey: "discountPercent",
      //   header: "% chiết khấu",
      // },
      // {
      //   accessorKey: "discountAmount",
      //   header: "Số tiền chiết khấu",
      //   Cell: ({ renderedCellValue, cell }) => (
      //     <NumberFormatter
      //       value={(renderedCellValue as string | number) || 0}
      //       suffix="₫"
      //       thousandSeparator="."
      //       decimalSeparator=","
      //     />
      //   ),
      // },
      //   {
      //     accessorKey: "appliesQuantity",
      //     header: "Áp dụng với số lượng Đ.H",
      //   },
      //   {
      //     accessorKey: "minimumValue",
      //     header: "Giá trị/Đ.Hàng tối thiểu",
      //   },
      //   {
      //     accessorKey: "total",
      //     header: "Tổng SL được mua cả C.Trình/1 Người",
      //   },
      // {
      //   accessorKey: "quantityMin",
      //   header: "SL tối thiểu 1 lần phải mua/1 Đ.Hàng",
      // },
      {
        accessorKey: "quantityMax",
        header: "SLượng tối đa 1 lần được mua/1 Đ.Hàng",
        enableGlobalFilter: false,
      },

      //   {
      //     accessorKey: "purchasedItems",
      //     header: "Mặt hàng đã mua",
      //   },
      //   {
      //     accessorKey: "bundledItems",
      //     header: "Mặt hàng mua kèm",
      //   },
      //   {
      //     accessorKey: "promotion",
      //     header: "Khuyến mại",
      //   },
      //   {
      //     accessorKey: "websitePromotion",
      //     header: "Khuyến mại Website",
      //   },
      //   {
      //     accessorKey: "applicableItems",
      //     header: "Mặt hàng được áp dụng",
      //   },
      //   {
      //     accessorKey: "allocationRate",
      //     header: "Tỷ lệ phân bổ",
      //     size: 200,
      //   },
    ],
    []
  );

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (465 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    form.setFieldValue("tblPromotionItemGiftModels", dataTemp);
  }, [dataTemp]);

  useEffect(() => {
    setData(form.getValues()?.tblPromotionItemGiftModels ?? []);
    setDataTemp(form.getValues()?.tblPromotionItemGiftModels ?? []);
  }, [form.getValues()]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef}>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
        >
          {/* <Button
            leftSection={<IconSearch size={14} />}
            color="blue"
            variant="outline"
            onClick={async () => {
              // await fetchData();
            }}
          >
            Lọc bảng giá
          </Button> */}
        </Flex>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    enableRowVirtualization: true,
    enableBatchRowSelection: true,
    enablePagination: true,
    selectAllMode: "all",
    // rowVirtualizerOptions: { overscan: 8 },
    getRowId: (row) => row?.idItemGift?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: [
          "mrt-row-select",
          "apply",
          "itemGiftCode",
          "namePurchase",
          "nameManufacturer",
        ],
        right: ["allocationRate", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      showGlobalFilter: true,
    },
    enableGlobalFilter: true,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    // manualPagination: true,
    // manualSorting: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        // fontWeight: "bold",
        fontSize: "11px",
        padding: "4px 12px",
      },
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      // showProgressBars: isRefetching,
      // showSkeletons: isLoading, //loading for the first time with no data
      //   sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: false,
    mantineTableProps: {
      striped: false,
    },
  });

  return <MantineReactTable table={table} />;
};

export default TableItemGiftPromotion;
